
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';

const PaymentCancel = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    navigate('/pricing');
  };

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="w-full max-w-md animate-fade-in-up">
        <Card className="tesla-card text-center">
          <CardHeader className="pb-8">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-red-50 rounded-full">
                <XCircle className="h-16 w-16 text-red-600" />
              </div>
            </div>
            <CardTitle className="text-3xl font-bold text-black mb-2">
              Payment Cancelled
            </CardTitle>
            <p className="text-gray-600 text-lg">
              Your payment was cancelled. No charges were made.
            </p>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              <p className="text-gray-700">
                Don't worry! You can try again anytime or continue using the free version 
                of our assessment platform.
              </p>
            </div>
            
            <div className="space-y-3">
              <Button 
                onClick={handleRetry}
                className="w-full tesla-accent-bg hover:bg-red-700 h-12"
              >
                <RefreshCw className="mr-2 h-4 w-4" />
                Try Again
              </Button>
              
              <Button 
                onClick={handleGoHome}
                variant="outline"
                className="w-full h-12"
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Go to Home
              </Button>
            </div>
            
            <p className="text-sm text-gray-500">
              Need help? Contact our support team for assistance.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancel;
